import React from "react";
import movie from "../../Assets/Projects/movie-booking.jpg";
import metric from "../../Assets/Projects/metric-conversion.jpg";
import easy from "../../Assets/Projects/easy-shift.jpg";
import iqra from "../../Assets/Projects/iqra-hospital.jpg";
import student from "../../Assets/Projects/student-grade.jpg";
import textAnalyzer from "../../Assets/Projects/Text-Analyzer.jpg";
import IOT from "../../Assets/Projects/IOT-Firebase.jpg";
import Backend from "../../Assets/Projects/Backend-API.jpg";
import ReactFirebase from "../../Assets/Projects/React-Dashboard.jpg";
import brandsgallary from "../../Assets/Projects/brandsgallary.jpg";
import Health from "../../Assets/Projects/health-website.jpg";
import { useNavigate } from "react-router-dom";

const cardData = [
  {
    id: 1,
    title: "Brands Gallary",
    image: brandsgallary,
    desc: "Brands Gallery, where fashion meets inspiration. We are a passionate community",
    link: "brands-gallary",
    tech1: "Html",
    tech2: "CSS",
    tech3: "JS",
    tech4: "Bootstrap",
    tech5: "Wordpress",
    tech6: "WooCommerce",
  },
  {
    id: 2,
    title: "Iqra Hospital Data Management",
    image: iqra,
    desc: "Iqra Hospital System is a patient information management",
    link: "iqra-hospital-data-management",
    tech1: "Html",
    tech2: "CSS",
    tech3: "Bootstrap",
    tech4: "Material UI",
    tech5: "React",
    tech6: "Firebase",
    tech7: "JavaScript",
  },
  {
    id: 3,
    title: "Metric Conversion",
    image: metric,
    desc: "Metric Conversion calculators and formulas for temperature, length, area, volume and weight",
    link: "metric-conversion",
    tech1: "Html",
    tech2: "CSS",
    tech3: "Bootstrap",
    tech4: "JavaScript",
    tech5: "Github",
  },
  {
    id: 4,
    title: "Easy Shift | Shifting Solution",
    image: easy,
    desc: "A days shifting of the employees with their login credentials",
    link: "easy-shift-shifting-solution",
    tech1: "Html",
    tech2: "CSS",
    tech3: "Bootstrap",
    tech4: "Material UI",
    tech5: "React",
    tech6: "Firebase",
    tech7: "JavaScript",
  },
  {
    id: 5,
    title: "Movie Booking System",
    image: movie,
    desc: "A movie booking system with seats booking and login / signup credentials",
    link: "movie-booking-system",
    tech1: "Html",
    tech2: "CSS",
    tech3: "Bootstrap",
    tech4: "Php",
    tech5: "MySQL",
    tech7: "JavaScript",
  },
  {
    id: 6,
    title: "Restful APIs Stucture & Design",
    image: Backend,
    desc: "Restful API's backend of session, tokens, express and node js",
    link: "restful-apis-stucture-design",
    tech1: "Express JS",
    tech2: "Node JS",
    tech3: "JWT Token",
    tech4: "JavaScript",
    tech5: "MVC Stucture",
    tech6: "MongoDB",
  },
  {
    id: 7,
    title: "Text Analyzer Using Django",
    image: textAnalyzer,
    desc: "Complete text analyzer using python framework django",
    link: "text-analyzer-using-django",
    tech1: "Html",
    tech2: "CSS",
    tech3: "Bootstrap",
    tech4: "Python",
    tech5: "Django",
    tech6: "Vercel",
  },
  {
    id: 8,
    title: "Student Grade Calculator",
    image: student,
    desc: "In This You can find your Percentages and Grades ",
    link: "student-grade-calculator",
    tech1: "Html",
    tech2: "CSS",
    tech3: "Bootstrap",
    tech4: "JavaScript",
    tech5: "Github",
  },
  {
    id: 9,
    title: "ESP32 IOT Firebase",
    image: IOT,
    desc: "This is the real time database connected with the esp32 chip and wifi",
    link: "esp32-iot-firebase",
    tech1: "C++",
    tech2: "ESP 32",
    tech3: "Firebase",
    tech4: "Arduino",
  },
  {
    id: 10,
    title: "React Firebase Dashboard",
    image: ReactFirebase,
    desc: "React material ui dashboard connected with firebase",
    link: "react-firebase-dashboard",
    tech1: "Html",
    tech2: "CSS",
    tech3: "Bootstrap",
    tech4: "Material UI",
    tech5: "React",
    tech6: "Firebase",
    tech7: "JavaScript",
  },
  {
    id: 11,
    title: "Health Website Template",
    image: Health,
    desc: "html css js bootstrap website template",
    link: "health-website-template",
    tech1: "Html",
    tech2: "CSS",
    tech3: "Bootstrap",
    tech4: "JavaScript",
  },
];

const ProjectPage = () => {
  const navigate = useNavigate();

  return (
    <div>
      <div className="container">
        <div className="row">
          {cardData.map((card, index) => (
            <div className="col-lg-3" key={index}>
              <div
                className="card shadow-box-2 bg-dark"
                style={{
                  color: "white",
                  height: "21.5rem",
                  cursor: "pointer",
                }}
                onClick={() => navigate(`/projects/${card.link}`)}
              >
                <img src={card.image} className="card-img-top" alt="..." />
                <div className="card-body">
                  <h6 className="card-title">{card.title}</h6>
                  <p className="small-text">{card.desc}</p>
                  <span class="badge text-bg-secondary" data-aos="flip-right">
                    {card.tech1}
                  </span>
                  &nbsp;
                  <span class="badge text-bg-secondary" data-aos="flip-right">
                    {card.tech2}
                  </span>
                  &nbsp;
                  <span class="badge text-bg-secondary" data-aos="flip-right">
                    {card.tech3}
                  </span>
                  &nbsp;
                  <span
                    class="badge text-bg-secondary mt-2"
                    data-aos="flip-right"
                  >
                    {card.tech4}
                  </span>{" "}
                  &nbsp;
                  <span
                    class="badge text-bg-secondary mt-2"
                    data-aos="flip-right"
                  >
                    {card.tech5}
                  </span>
                  &nbsp;
                  <span
                    class="badge text-bg-secondary mt-2"
                    data-aos="flip-right"
                  >
                    {card.tech6}
                  </span>
                  &nbsp;
                  <span
                    class="badge text-bg-secondary mt-2"
                    data-aos="flip-right"
                  >
                    {card.tech7}
                  </span>
                  {/* <a href="#" className="btn btn-primary">
                    Go somewhere
                  </a> */}
                </div>
              </div>
              <br />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectPage;
